<template>
  <div class="bg-white rounded-lg shadow p-4">
    <div class="flex items-center justify-between mb-3">
      <div class="font-semibold text-dark-primary">Contacts</div>
      <div v-if="sortedContacts.length > 0" class="flex items-center space-x-3 text-sm">
        <button class="px-2 text-lg disabled:text-gray-300" :disabled="index === 0" @click="index--">‹</button>
        <div>{{ index + 1 }} of {{ sortedContacts.length }}</div>
        <button class="px-2 text-lg disabled:text-gray-300" :disabled="index === sortedContacts.length - 1" @click="index++">›</button>
      </div>
    </div>

    <div v-if="!contact" class="text-sm text-gray-500">No contacts</div>
    <div v-else class="space-y-1 text-sm">
      <div class="flex items-center space-x-2">
        <div class="text-base font-semibold">{{ contactName(contact) || '--' }}</div>
        <span v-if="contact.is_primary_contact" class="text-xs px-2 py-0.5 rounded-full bg-accent-primary text-white">Primary</span>
      </div>
      <div v-if="contact.title" class="text-gray-600">{{ contact.title }}</div>
      <a v-if="contact.email_address" :href="`mailto:${contact.email_address}`" class="block text-accent-primary break-all">{{ contact.email_address }}</a>
      <a v-if="contact.phone_number" :href="`tel:${contact.phone_number}`" class="block text-accent-primary">{{ contact.phone_number }}</a>
      <a v-if="linkedinUrl" :href="linkedinUrl" target="_blank" rel="noopener" class="block text-accent-primary">LinkedIn</a>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineProps } from 'vue';
import { contactName } from '@/components/mobile/contact/contactDisplay';

const props = defineProps({
  contacts: Array
})

const index = ref(0)

const sortedContacts = computed(() => {
  return [...(props.contacts || [])].sort((a, b) => Number(!!b.is_primary_contact) - Number(!!a.is_primary_contact))
})

const contact = computed(() => sortedContacts.value[index.value])

const linkedinUrl = computed(() => {
  const profile = contact.value && contact.value.contact && contact.value.contact.linkedin_profile
  if (!profile) {
    return null
  }
  return profile.startsWith('http') ? profile : `https://www.linkedin.com/${profile}`
})

watch(() => props.contacts, () => {
  index.value = 0
})
</script>
